import type { ApiError } from '@app/services/api.types';
import webchatApi from '@app/services/webchat-api';
import type {
    SendChatMessageParams,
    SendChatMessageResponse,
    WebchatTurn,
} from '@app/services/webchat.types';
import { apiEndpoints } from '@app/utils/constants';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export const sendChatMessage = async (params: SendChatMessageParams): Promise<WebchatTurn> => {
    const url = apiEndpoints.webchat.sendMessage(params.agentId, params.sessionId);
    const response = await webchatApi.post<SendChatMessageResponse>(url, {
        message: params.message,
    });
    return response.data.data;
};

const useSendChatMessage = () => {
    return useMutation<WebchatTurn, AxiosError<ApiError>, SendChatMessageParams>({
        mutationFn: sendChatMessage,
        meta: {
            skipGlobalErrorHandling: true,
        },
    });
};

export default useSendChatMessage;
